import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from 'vue-auto-routing';

function register() {
  const files = require.context('../', true, /\.vue$/i);
  files
    .keys()
    .map(key => Vue.component((key.split('/').pop() || '').split('.')[0], files(key).default));
}

register();

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: [...routes, { path: '*', component: Vue.component('AxNotFound') }]
});

export default router;
